import MenuItem from '@mui/material/MenuItem';
import * as Styles from '../Header.styles';

const ProfileMenu = ({ anchorEl, setAnchorEl, accountInformationData }) => {
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const havePackageUse =
    accountInformationData && accountInformationData.packageName;

    const getTooltipContent = () => {
      if (!accountInformationData) {
        return null;
      }

      return (
        <a href="/profile">
          <div className="text-base text-black dark:text-white text-left ml-2 hidden lg:block">
            <div className="w-full font-bold">{accountInformationData.fullName}</div>
            <div
              className="w-full text-xs"
              data-userid={accountInformationData.userId}
            >
              A{accountInformationData.userId}
            </div>
          </div>
        </a>
      )
    }

  return (
    <Styles.ProfileMenu
      MenuListProps={{
        className: 'customDivider',
      }}
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem disableRipple style={{ whiteSpace: 'normal', cursor: 'default' }}>
        <ul className="z-[400] w-56 p-2 space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:border-gray-700 dark:text-gray-300 dark:bg-gray-700">
          <li>
            {getTooltipContent()}
          </li>
          <li className="flex">
            <a
              className="inline-flex items-center w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"
              href="/profile"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 mr-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
              <span>Hồ sơ</span>
            </a>
          </li>
          <li className="flex border-t-2 border-dashed"></li>
          <li className="flex">
            {havePackageUse && (
              <span className="px-2 text-sm text-gray-600 dark:text-gray-300">
                Bạn đang sử dụng gói <b>{accountInformationData.packageName}</b>{' '}
                và sẽ hết hạn vào ngày:{' '}
                <span>{accountInformationData.packageExpiredDate}</span>.
              </span>
            )}
            {!havePackageUse && (
              <span className="px-2 text-sm text-gray-600 dark:text-gray-300">
                Bạn đang sử dụng gói{' '}
                <span className="font-semibold">"Miễn phí"</span>, hãy nâng cấp
                lên bảng chuyên nghiệp để sử dụng đầy đủ tính năng.
              </span>
            )}
          </li>
          {!havePackageUse && (
            <li className="flex">
              <a
                className="inline-flex items-center w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"
                href="/upgrade"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 mr-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="1"
                >
                  <path
                    id="Path_15"
                    d="M518.8,829.36c-.678,1.556-1.213,2.66-2.709,2.66h-8.128a2.664,2.664,0,0,1-2.71-2.66l-.8-7.36h-3.484v-1h4.375l.361,3.014h15.358Zm-12.556,0a1.874,1.874,0,0,0,1.72,1.633H516.1c.9,0,1.271-.72,1.657-1.633l1.837-4.382H505.8Zm1.225,3.64a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,507.474,833Zm-.531,1.969h1V834h-1ZM515.474,833a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,515.474,833Zm-.531,1.969h1V834h-1Z"
                    transform="translate(-500.973 -821)"
                  />
                </svg>
                <span>Nâng cấp/Gia hạn</span>
              </a>
            </li>
          )}
          <li className="flex">
            <a
              className="inline-flex items-center w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"
              href="/profile#billing"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 mr-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="1"
              >
                <path d="M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-.9 2-2 2H4v-2h17V7h2z" />
              </svg>
              <span>Lịch sử thanh toán</span>
            </a>
          </li>

          <li className="flex border-t-2 border-dashed"></li>

          <li className="flex">
            <a
              className="inline-flex items-center w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"
              href="/logout"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 mr-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
              <span>Đăng xuất</span>
            </a>
          </li>
        </ul>
      </MenuItem>
    </Styles.ProfileMenu>
  );
};

export default ProfileMenu;
